import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { PerformanceTeamReview } from './performance-team-review.model';

export class PerformanceTeamReviewStateModel extends EntityStateModel<PerformanceTeamReview> {}
